import { faBook } from "@fortawesome/pro-regular-svg-icons/faBook";
import { faBuildingColumns } from "@fortawesome/pro-regular-svg-icons/faBuildingColumns";
import { faCartShopping } from "@fortawesome/pro-regular-svg-icons/faCartShopping";
import { faHeart } from "@fortawesome/pro-regular-svg-icons/faHeart";
import { faBed } from "@fortawesome/pro-solid-svg-icons/faBed";
import { faCamera } from "@fortawesome/pro-solid-svg-icons/faCamera";
import { faForkKnife } from "@fortawesome/pro-solid-svg-icons/faForkKnife";
import { faLandmark } from "@fortawesome/pro-solid-svg-icons/faLandmark";
import { faMugHot } from "@fortawesome/pro-solid-svg-icons/faMugHot";
import { faTrees } from "@fortawesome/pro-solid-svg-icons/faTrees";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CameraColor from './illustratores/CameraColor';
import CartColor from './illustratores/CartColor';
import GlassIcons from './illustratores/GlassIcon';
import NoActivity from './illustratores/NoActivity';
import NoCafe from './illustratores/NoCafe';
import NoMuseum from './illustratores/NoMuseum';
import NoPark from './illustratores/NoPark';
import NoRestaurant from './illustratores/NoRestaurant';

export type ActivityIconsType = keyof typeof rawIcons

export const rawIcons = {
    tourist: { color: '#7e3af2', icon: <FontAwesomeIcon icon={faCamera} size='xl' className="w-5 h-5" /> },
    historical: { color: '#6c1f1a', icon: <FontAwesomeIcon icon={faLandmark} size='xl' className="w-5 h-5" /> },
    monument: { color: '#6c1f1a', icon: <FontAwesomeIcon icon={faBuildingColumns} /> },
    religious: { color: '#6c1f1a', icon: <FontAwesomeIcon icon={faBuildingColumns} /> },
    museum: { color: '#6c1f1a', icon: <FontAwesomeIcon icon={faLandmark} size='xl' className="w-5 h-5" /> },
    neighborhood: { color: '#7e3af2', icon: <FontAwesomeIcon icon={faCamera} size='xl' className="w-5 h-5" /> },
    street: { color: '#7e3af2', icon: <FontAwesomeIcon icon={faCamera} size='xl' className="w-5 h-5" /> },
    shopping: { color: '#446dd4', icon: <FontAwesomeIcon icon={faCartShopping} size='xl' className="w-5 h-5" /> },
    shop: { color: '#446dd4', icon: <FontAwesomeIcon icon={faCartShopping} size='xl' className="w-5 h-5" /> },
    dining: { color: '#ff8731', icon: <FontAwesomeIcon icon={faForkKnife} size='xl' className="w-4 h-4" /> },
    cafe: { color: '#ff8731', icon: <FontAwesomeIcon icon={faMugHot} size='xl' className="w-5 h-4" /> },
    food: { color: '#ff8731', icon: <FontAwesomeIcon icon={faForkKnife} size='xl' className="w-4 h-4" /> },
    restaurant: { color: '#ff8731', icon: <FontAwesomeIcon icon={faForkKnife} size='xl' className="w-4 h-4" /> },
    park: { color: '#0f7e0d', icon: <FontAwesomeIcon icon={faTrees} size='xl' className="w-5 h-5" /> },
    nature: { color: '#0f7e0d', icon: <FontAwesomeIcon icon={faTrees} size='xl' className="w-5 h-5" /> },
    hotel: { color: '#34344', icon: <FontAwesomeIcon icon={faBed} size='xl' className="w-5 h-5" /> },
    meal_takeaway: { color: '#7e3af2', icon: <FontAwesomeIcon icon={faCamera} size='xl' className="w-5 h-5" /> },
    bar: { color: '#446dd4', icon: <GlassIcons className='w-5' /> },
    night_club: { color: '#446dd4', icon: <GlassIcons className='w-5' /> },
    nightlife: { color: '#446dd4', icon: <GlassIcons className='w-5' /> },
    book_store: { color: '#7e3af2', icon: <FontAwesomeIcon icon={faCamera} size='xl' className="w-5 h-5" /> },
    tourist_attraction: { color: '#7e3af2', icon: <FontAwesomeIcon icon={faCamera} size='xl' className="w-5 h-5" /> },
    all: { color: '#7e3af2', icon: <FontAwesomeIcon icon={faCamera} size='xl' className="w-5 h-5" /> },
};


export const placeIcons: any = {
    Meal: <FontAwesomeIcon icon={faLandmark} className="text-white" />,
    Sightseeing: <CameraColor />,
    Shopping: <CartColor className='text-[#00B8DB]' />,
    Nature: <FontAwesomeIcon icon={faLandmark} className="text-white" />,
    Historical: <FontAwesomeIcon icon={faLandmark} className="text-white" />,
    Tourist: <FontAwesomeIcon icon={faBuildingColumns} className="text-white" />,
    Monument: <FontAwesomeIcon icon={faBuildingColumns} className="text-white" />,
    Religious: <FontAwesomeIcon icon={faBuildingColumns} className="text-white" />,
    Neighborhood: <FontAwesomeIcon icon={faBuildingColumns} className="text-white" />,
    Street: <FontAwesomeIcon icon={faBuildingColumns} className="text-white" />,
    Dining: <FontAwesomeIcon icon={faForkKnife} className="text-white" />,
    Food: <FontAwesomeIcon icon={faForkKnife} className="text-white" />,
    Museum: <FontAwesomeIcon icon={faLandmark} className="text-white" />,
    Park: <FontAwesomeIcon icon={faTrees} className="text-white" />,
    Cafe: <FontAwesomeIcon icon={faMugHot} className="text-white" />,
    Hotel: <FontAwesomeIcon icon={faBed} className="text-white" />,
    restaurant: <FontAwesomeIcon icon={faForkKnife} className="text-white" />,
    food: <FontAwesomeIcon icon={faForkKnife} className="text-white" />,
    meal_takeaway: <FontAwesomeIcon icon={faForkKnife} className="text-white" />,
    cafe: <FontAwesomeIcon icon={faMugHot} className="text-white" />,
    nature: <FontAwesomeIcon icon={faTrees} className="text-white" />,
    book_store: <FontAwesomeIcon icon={faBook} className="text-white" />,
    all: <FontAwesomeIcon icon={faBuildingColumns} className="text-white" />,
};

export const placeIconsBlack: any = {
    Historical: <FontAwesomeIcon icon={faBuildingColumns} className="text-neutral-500" size="sm" />,
    Tourist: <FontAwesomeIcon icon={faBuildingColumns} className="text-neutral-500" size="sm" />,
    Monument: <FontAwesomeIcon icon={faBuildingColumns} className="text-neutral-500" size="sm" />,
    Religious: <FontAwesomeIcon icon={faBuildingColumns} className="text-neutral-500" size="sm" />,
    Neighborhood: <FontAwesomeIcon icon={faBuildingColumns} className="text-neutral-500" size="sm" />,
    Street: <FontAwesomeIcon icon={faBuildingColumns} className="text-neutral-500" size="sm" />,
    Shopping: <FontAwesomeIcon icon={faCartShopping} className="text-neutral-500" size="sm" />,
    Dining: <FontAwesomeIcon icon={faForkKnife} className="text-neutral-500" size="sm" />,
    Food: <FontAwesomeIcon icon={faForkKnife} className="text-neutral-500" size="sm" />,
    Museum: <FontAwesomeIcon icon={faLandmark} className="text-neutral-500" size="sm" />,
    Park: <FontAwesomeIcon icon={faTrees} className="w-4 text-neutral-500" size="sm" />,
    Cafe: <FontAwesomeIcon icon={faMugHot} size='sm' className=" text-neutral-500" />,
    Hotel: <FontAwesomeIcon icon={faBed} className="text-neutral-500" />,
    restaurant: <FontAwesomeIcon icon={faForkKnife} className="text-neutral-500" size="sm" />,
    meal_takeaway: < FontAwesomeIcon icon={faForkKnife} className="text-neutral-500" size="sm" />,
    cafe: <FontAwesomeIcon icon={faMugHot} size='sm' className="text-neutral-500" />,
};

export const filterIcons: any = {
    historical: <FontAwesomeIcon icon={faLandmark} size="sm" />,
    tourist: <FontAwesomeIcon icon={faBuildingColumns} size="sm" />,
    monument: <FontAwesomeIcon icon={faBuildingColumns} size="sm" />,
    religious: <FontAwesomeIcon icon={faBuildingColumns} size="sm" />,
    neighborhood: <FontAwesomeIcon icon={faBuildingColumns} size="sm" />,
    street: <FontAwesomeIcon icon={faBuildingColumns} size="sm" />,
    shopping: <FontAwesomeIcon icon={faCartShopping} size="sm" />,
    dining: <FontAwesomeIcon icon={faForkKnife} size="sm" />,
    food: <FontAwesomeIcon icon={faForkKnife} size="sm" />,
    museum: <FontAwesomeIcon icon={faLandmark} size="sm" />,
    park: <FontAwesomeIcon icon={faTrees} size="sm" />,
    cafe: <FontAwesomeIcon icon={faMugHot} size='sm' />,
    hotel: <FontAwesomeIcon icon={faBed} size='sm' className="w-4 h-4" />,
    restaurant: <FontAwesomeIcon icon={faForkKnife} size="sm" />,
    meal_takeaway: <FontAwesomeIcon icon={faForkKnife} size="sm" />,
    shop: <FontAwesomeIcon icon={faCartShopping} size="sm" />,
    health: <FontAwesomeIcon icon={faHeart} className="w-4 " />,
    nature: <FontAwesomeIcon icon={faTrees} size="sm" />,
    book_store: <FontAwesomeIcon icon={faBook} className="w-4 " />,
    all: <FontAwesomeIcon icon={faBuildingColumns} size="sm" />,
};

export const placeHolders = {
    restaurant: <NoRestaurant />,
    cafe: <NoCafe />,
    museum: <NoMuseum />,
    park: <NoPark />,
    tourist_attraction: <NoActivity />,
}